jQuery(function($) {

    // Check if flexslider is loaded
    if ($('.flexslider').length > 0) {

        // Randomize slides on .random sliders
        $('.random .flexslider').flexslider({
            randomize: true
        });
    }
});